import styles from "./prizeTicketSelector.module.css";
import { PrizeTicketProps } from "./types";
import ChevronsRightIcon from "../../shared-components/icons/ChevronsRightIcon";

const SubscriptionTab = (props: { competitionName: string; prizeDetails: PrizeTicketProps }) => {
  const { competitionName, prizeDetails } = props;

  const subscribeClick = () => {
    if (prizeDetails.UTMForSubscriptionTab) {
      location.href = `/botb-pass?utm_medium=${prizeDetails.UTMForSubscriptionTab}`;
      return;
    }
    location.href = "/botb-pass";
  };

  return (
    <div className={"max-lg:max-h-[80vh] max-lg:overflow-y-auto"}>
      <div className={"flex flex-col items-center w-full mb-8 text-center lg:mb-6 pt-5 lg:pt-4"}>
        <div
          className={
            "flex ml-auto uppercase text-white text-xs font-jost font-semibold rounded-[5px] px-2.5 py-1 bg-end-date-badge lg:text-sm lg:mr-3"
          }>
          save up to 75%*
        </div>
        <div className={"font-jost text-xl leading-6.5 text-dark-1 font-bold mb-2 lg:text-2xl lg:leading-7.5"}>
          The Smarter Way to Play
        </div>
        <div className={"font-jost text-base leading-5.5 font-normal px-5 text-gray-1 lg:text-lg lg:leading-6"}>
          Get entries to <strong className={"font-medium"}>{competitionName}</strong> and over 20 monthly competitions!
        </div>
      </div>

      <div className={"relative mx-4 mb-4 h-14 rounded-lg lg:h-16"}>
        <img
          src={"/assets/images/botb-pass/botbpass100x40v2.png"}
          alt={"banner"}
          width={692}
          height={128}
          className={"size-full object-contain relative rounded-lg z-10"}
        />
      </div>

      <div className={"mx-4 mb-8 flex items-center lg:mb-3"}>
        <div className={"flex items-center gap-2"}>
          <div className={"min-w-8"}>
            <img
              src={"/assets/images/botb-pass/cup.webp"}
              alt={"cars-only"}
              width={64}
              height={65}
              className={"size-8"}
            />
          </div>
          <div className={"font-bold font-jost text-lg text-dark-1 lg:text-xl"}>21</div>
          <div className={"text-gray-1 text-xs font-medium font-jost leading-3 lg:text-sm"}>Monthly competitions</div>
        </div>
        <div className={"w-0.5 h-6 bg-black/8 mx-2"}></div>
        <div className={"flex items-center gap-2"}>
          <div className={"min-w-8"}>
            <img
              src={"/assets/images/botb-pass/gift.webp"}
              alt={"cars-only"}
              width={64}
              height={65}
              className={"size-8"}
            />
          </div>
          <div className={"font-bold font-jost text-lg text-dark-1 lg:text-xl"}>£2.3M</div>
          <div className={"text-gray-1 text-xs font-jost leading-3 lg:text-sm"}>Available in prizes</div>
        </div>
      </div>

      <div className={"flex-center gap-2.5 font-jost mb-[14px]"}>
        <div className={"size-[18px]"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M10 7H10.01M9 10H10V14H11M1 10C1 11.1819 1.23279 12.3522 1.68508 13.4442C2.13738 14.5361 2.80031 15.5282 3.63604 16.364C4.47177 17.1997 5.46392 17.8626 6.55585 18.3149C7.64778 18.7672 8.8181 19 10 19C11.1819 19 12.3522 18.7672 13.4442 18.3149C14.5361 17.8626 15.5282 17.1997 16.364 16.364C17.1997 15.5282 17.8626 14.5361 18.3149 13.4442C18.7672 12.3522 19 11.1819 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1C7.61305 1 5.32387 1.94821 3.63604 3.63604C1.94821 5.32387 1 7.61305 1 10Z"
              stroke="#4C4C52"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className={"text-secondary text-sm font-medium"}>Cancel anytime</div>
      </div>

      <div className={"text-center font-medium leading-3.5 px-6 lg:px-14 mb-3 lg:mb-2"}>
        <p className={"text-gray-5 font-jost text-xs"}>
          *Savings shown relates to tickets in BOTB Ultimate Pass yearly vs. buying tickets separately
        </p>
      </div>

      <div className={"max-lg:px-4"}>
        <button
          onClick={subscribeClick}
          className={`theme-btn theme-btn-primary theme-btn-lg uppercase w-full ${styles.addToBasket} btnWithArrow`}>
          <span className="relative">
            SUBSCRIBE NOW{" "}
            <ChevronsRightIcon
              variant={3}
              className={"size-6 shrink-0 absolute left-[calc(100%+theme(spacing.2))] inset-y-0 my-auto arrowImage"}
            />
          </span>
        </button>
      </div>
    </div>
  );
};

export default SubscriptionTab;
